import { TAB, ARROW_UP, ENTER, ARROW_DOWN } from '@anthem/uxd/util';
import * as i0 from '@angular/core';
import { forwardRef, EventEmitter, ViewContainerRef, Component, Input, Output, ViewChildren, ViewChild, HostListener, Directive, ContentChild, ContentChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';

const AUTOSUGGEST_COMPONENT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AutoSuggestComponent),
    multi: true
};
class AutoSuggestComponent {
    static { this.COUNT = 0; }
    _onChangeCallback(value) {
        // noop
    }
    _onTouchedCallback() {
        // noop
    }
    set alphabetize(alphabetize) {
        this._sortingFilter = alphabetize;
    }
    constructor(eleRef, _renderer) {
        this.eleRef = eleRef;
        this._renderer = _renderer;
        this._result = [];
        this._noSuggestions = false;
        this._selectedIndex = -1;
        this._sortingFilter = true;
        this.legend = '';
        this.ignoreCase = true;
        this.ariaSearchButton = 'Search';
        this.noSuggestionsMsg = 'No suggestions found';
        this.noAutoSuggest = false;
        this.analytics = null;
        this.isDisabled = false;
        this.onChange = new EventEmitter();
        this.itemsHeight = 100;
        this.dropdownOpened = false;
        this.qText = "";
        this.dropDownType = "";
        this.optionSelected = false;
        this._idPrefix = "uxd-auto-suggest-cmp-" + AutoSuggestComponent.COUNT + "-";
        AutoSuggestComponent.COUNT++;
    }
    ngOnInit() {
        this.qText = this.defaultText;
    }
    set items(value) {
        if (this._items !== value) {
            this._items = value;
        }
    }
    get items() {
        return this._items;
    }
    set idPrefix(val) {
        this._idPrefix = val;
    }
    get idPrefix() {
        return this._idPrefix;
    }
    get result() {
        return this._result;
    }
    get noSuggestions() {
        return this._noSuggestions;
    }
    get selectedIndex() {
        return this._selectedIndex;
    }
    openDropDown() {
        this.dropdownOpened = true;
        let maxNumOfVisibleItems = 4.5;
        let singleItemHeight = 41;
        if (this.itemLabels.first) {
            singleItemHeight = $(this.itemLabels.first.element.nativeElement).outerHeight();
        }
        this.itemsHeight = singleItemHeight * maxNumOfVisibleItems;
        if (this._result.length < 6) {
            this.itemsHeight = this._result.length * singleItemHeight;
        }
        else if (this._result.length === 0) {
            this.itemsHeight = singleItemHeight;
        }
        this.itemsHeight = this.itemsHeight + 4;
        if (this.dropDown) {
            this.dropDown.element.nativeElement.scrollTop = 0;
        }
    }
    closeDropDown() {
        this.dropdownOpened = false;
    }
    emitSearchEvent() {
        if (this.qText.trim().length > 0) {
            this.onChange.emit(this.getValueFromSelectedItem(this.qText).value);
        }
    }
    // toggleSorting() {
    //   if (!this._sortingFilter) {
    //     this._sortingFilter = true;
    //   }
    // }
    /**
     * On Focus event listener for the Input field.
     * @param event
     */
    onInputFocus(event) {
        //When user presses Tab or SHIFT+Tab
        if (this.qText.trim() === this.defaultText) {
            this.qText = "";
        }
        this.optionSelected = false;
        if (!this.dropdownOpened) {
            this.calculateSuggestion();
            this.openDropDown();
        }
    }
    /**
     * Keyboard key down event listener for the Input field.
     * @param event
     */
    onInputFieldKeyDown(event) {
        if (event.keyCode === TAB || (event.keyCode === TAB && event.shiftKey)) {
            this.onItemClick(this.qText);
            return;
        }
        if (event.keyCode === ARROW_UP) {
            event.preventDefault();
            return;
        }
    }
    /**
     * Keyboard event listener for the Input field.
     * @param event
     */
    onInputFieldKeyUp(event) {
        //When user  enter, do nothing if no matches text available
        if (event.keyCode === ENTER) {
            let selectedVal = this.getValueFromSelectedItem(this.qText);
            if (selectedVal.label) {
                this.onItemClick(selectedVal.label);
            }
            return;
        }
        //When user presses SHIFT + ENTER, CTRL + ENTER,  CTRL + SHIFT+ ENTER
        if ((event.keyCode === ENTER && event.shiftKey) ||
            (event.keyCode === ENTER && event.ctrlKey) ||
            (event.keyCode === ENTER && event.ctrlKey && event.shiftKey)) {
            //Do nothing
            event.stopPropagation();
            return;
        }
        //When user presses ARROW_DOWN arrow key
        //Select the first item in the drop-down-list
        //
        if (event.keyCode === ARROW_UP || event.keyCode === ARROW_DOWN) {
            let selected;
            let current;
            if (event.keyCode === ARROW_UP) {
                this._selectedIndex--;
                if (this._selectedIndex < 0) {
                    this._selectedIndex = this.result.length - 1;
                }
                selected = this.itemInputs.toArray()[this._selectedIndex];
                current = this.itemLabels.toArray()[this._selectedIndex];
            }
            if (event.keyCode === ARROW_DOWN) {
                this._selectedIndex++;
                if (this._selectedIndex > this.result.length - 1) {
                    this._selectedIndex = 0;
                }
                selected = this.itemInputs.toArray()[this._selectedIndex];
                current = this.itemLabels.toArray()[this._selectedIndex];
            }
            this.dropDown.element.nativeElement.scrollTop = 0;
            if (current) {
                this.dropDown.element.nativeElement.scrollTop =
                    current.element.nativeElement.offsetTop;
            }
            if (selected) {
                this._renderer.addClass(selected.element.nativeElement, "highlight");
                this.qText = selected.element.nativeElement.defaultValue;
            }
            return;
        }
        this._selectedIndex = -1;
        this.calculateSuggestion();
        this.openDropDown();
    }
    onItemChange(event) {
        if (this.isValidOption(event)) {
            this._onChangeCallback(this.getValueFromSelectedItem(event.toUpperCase()).value);
        }
        else {
            this._onChangeCallback("");
        }
    }
    getFirstFilteredItem() {
        return this._result[0];
    }
    onSearchButtonClick(evt) {
        if (this.dropdownOpened) {
            this.onItemClick(this.qText);
        }
        else {
            this.searchInput.nativeElement.focus();
        }
    }
    onItemClick(item) {
        let selectedVal = this.getValueFromSelectedItem(item);
        if (selectedVal.label) {
            this.qText = selectedVal.label;
        }
        else {
            this.qText = this.defaultText;
        }
        this.closeDropDown();
        this.onChange.emit(selectedVal.value);
        this._onChangeCallback(selectedVal.value);
    }
    calculateSuggestion() {
        if (!(this._items instanceof Array)) {
            //items property should be an array of strings
            return;
        }
        if (this.items.length === 0) {
            //items property is mandatory to calculate suggestions
            this._result.length = 0;
            this._noSuggestions = false;
            return;
        }
        let q = this.qText ? this.qText.trim() : "";
        q = q.replace("*", "");
        q = q.replace("^", "");
        q = q.replace("(", "");
        q = q.replace(")", "");
        q = q.replace("[", "");
        q = q.replace("]", "");
        q = q.replace("\\", "");
        q = q.replace("+", "");
        q = q.replace("-", "");
        q = q.replace("?", "");
        q = q.replace("=", "");
        q = q.replace("$", "");
        q = q.replace("&", "");
        q = q.replace("#", "");
        q = q.replace("%", "");
        q = q.replace("!", "");
        q = q.replace("~", "");
        q = q.replace("`", "");
        q = q.replace(",", "");
        q = q.replace(":", "");
        q = q.replace("|", "");
        q = q.replace("/", "");
        /*if (q === '') {
          //qText is mandatory to calculate suggestions
          this._result.length = 0;
          this._noSuggestions = false;
          return;
        }*/
        //Calculate Suggestions
        let startsWithQuery = [];
        let containsQuery = [];
        let doesNotContainQuery = [];
        this.items.forEach((item) => {
            let flags = "g" + (this.ignoreCase ? "i" : "");
            let qRegExp = new RegExp(q, flags);
            if (this.itemsContainParentheses === true) {
                let label = item.label.replace(")", "");
                label = label.replace("(", "");
                let r = qRegExp.exec(label);
                this.createResultArrayFromQuery(r, item, flags, qRegExp, startsWithQuery, containsQuery, doesNotContainQuery);
            }
            else {
                let r = qRegExp.exec(item.label);
                this.createResultArrayFromQuery(r, item, flags, qRegExp, startsWithQuery, containsQuery, doesNotContainQuery);
            }
        });
        //Sort the result
        //1. Bring all starting-with to the begining of the array
        let sortByAlphabet;
        sortByAlphabet = (a, b) => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        };
        if (this._sortingFilter) {
            startsWithQuery = startsWithQuery.sort(sortByAlphabet);
            containsQuery = containsQuery.sort(sortByAlphabet);
        }
        this._result = startsWithQuery.concat(containsQuery);
        if (this._result.length === 0) {
            this._noSuggestions = true;
        }
        else {
            this._noSuggestions = false;
        }
        if (this.noAutoSuggest) {
            doesNotContainQuery = doesNotContainQuery.sort(sortByAlphabet);
            this._result = this._result.concat(doesNotContainQuery);
        }
    }
    onDocumentClick(event) {
        if (this.dropdownOpened) {
            if (event.target !== this.eleRef.nativeElement &&
                !this.eleRef.nativeElement.contains(event.target)) {
                this.onItemClick(this.qText);
            }
        }
    }
    resetSearch() {
        this.qText = this.defaultText;
    }
    createResultArrayFromQuery(r, item, flags, qRegExp, startsWithQuery, containsQuery, doesNotContainQuery) {
        if (r) {
            let isContains = r.length > 0;
            let isStartsWith = r.index === 0;
            if (isStartsWith) {
                startsWithQuery.push(item);
            }
            else if (isContains) {
                containsQuery.push(item);
            }
            else {
                this._noSuggestions = true;
            }
        }
        else {
            if (item && item.label) {
                doesNotContainQuery.push(item);
            }
        }
        flags = undefined;
        qRegExp = undefined;
        r = undefined;
    }
    getValueFromSelectedItem(text) {
        text = text.trim().toUpperCase();
        let retObj = { value: "", label: "" };
        if (text === "") {
            return retObj;
        }
        else {
            this.items.forEach((item) => {
                if (item.label.toUpperCase() === text) {
                    retObj = item;
                    return;
                }
            });
            return retObj;
        }
    }
    writeValue(value) {
        this.qText = value ? value : this.defaultText;
    }
    registerOnChange(fn) {
        //todo
        this._onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this._onTouchedCallback = fn;
    }
    isValidOption(keyword) {
        let isPresent = false;
        keyword = keyword.toUpperCase();
        this.items.forEach((item) => {
            if (item.label.toUpperCase() === keyword) {
                isPresent = true;
                return;
            }
        });
        return isPresent;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AutoSuggestComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AutoSuggestComponent, selector: "[data-uxd-auto-suggest-cmp]", inputs: { legend: "legend", ignoreCase: "ignoreCase", ariaSearchButton: "ariaSearchButton", noSuggestionsMsg: "noSuggestionsMsg", labelText: "labelText", defaultText: "defaultText", noAutoSuggest: "noAutoSuggest", alphabetize: "alphabetize", itemsContainParentheses: "itemsContainParentheses", analytics: "analytics", isDisabled: "isDisabled", items: "items", idPrefix: "idPrefix" }, outputs: { onChange: "onChange" }, host: { listeners: { "document:click": "onDocumentClick($event)" } }, providers: [AUTOSUGGEST_COMPONENT_VALUE_ACCESSOR], viewQueries: [{ propertyName: "dropDown", first: true, predicate: ["psDropdown"], descendants: true, read: ViewContainerRef }, { propertyName: "searchInput", first: true, predicate: ["searchInput"], descendants: true }, { propertyName: "itemLabels", predicate: ["itemLabel"], descendants: true, read: ViewContainerRef }, { propertyName: "itemInputs", predicate: ["itemInput"], descendants: true, read: ViewContainerRef }], ngImport: i0, template: `
  <fieldset class="ant-auto-suggest" [ngClass]="{'borderless': (dropDownType === 'borderless')}">

    <legend [id]="idPrefix+'legend'" [innerHTML]="legend"></legend>

    <input #searchInput [disabled]="isDisabled" [id]="idPrefix+'q-field'" class="ant-text-input ant-search-input" type="text" (focus)="onInputFocus($event)" (keydown)="onInputFieldKeyDown($event)" (keyup)="onInputFieldKeyUp($event)" (ngModelChange)="onItemChange($event)" [(ngModel)]="qText" autocomplete="off"/>    <label *ngIf="labelText" class="sr-only" [id]="idPrefix + 'search-box-label'" [attr.for]="idPrefix+'q-field'" [innerText]="labelText"></label>

    <button type="button" [disabled]="isDisabled" #searchBtn class="ant-search-button psButton" tabindex="-1" [id]="idPrefix+'search-btn'" (click)="onSearchButtonClick($event)">
      <span class="sr-only" [innerText]="ariaSearchButton"></span>
      <span class="psArrow fa fa-caret-down"></span>
    </button>

    <div #psDropdown [id]="idPrefix+'psDropdown-container'" class="psDropdown" tabindex="-1" *ngIf="dropdownOpened" [style.height]="itemsHeight+'px'" [ngClass]="{'active': dropdownOpened, 'noresults': noSuggestions}">

        <div *ngIf="noSuggestions" [innerText]="noSuggestionsMsg" class="no-suggestions">
        </div>

        <ng-container *ngFor="let item of result; let i = index;">

          <input #itemInput
            [id]="idPrefix+'ddlInput'+i"
            [attr.name]="idPrefix+'ddlInput'"
            type="radio"
            class="psOption"
            [value]="item.label"
            [attr.data-analytics]="item.analytics ? item.analytics : null"
            [checked]="selectedIndex === i"
            (click)="onItemClick(item.label)"/>

          <label #itemLabel
            [id]="idPrefix+'ddlLabel'+i"
            [ngClass]="{'psDisabled': item.disabled, 'active': (item.label.toUpperCase() === qText.trim().toUpperCase())}"
            [attr.for]="idPrefix+'ddlInput'+i"
            class="psLabel"
            [innerHTML]="item.label">
          </label>

        </ng-container>
    </div>

  </fieldset>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AutoSuggestComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "[data-uxd-auto-suggest-cmp]",
                    template: `
  <fieldset class="ant-auto-suggest" [ngClass]="{'borderless': (dropDownType === 'borderless')}">

    <legend [id]="idPrefix+'legend'" [innerHTML]="legend"></legend>

    <input #searchInput [disabled]="isDisabled" [id]="idPrefix+'q-field'" class="ant-text-input ant-search-input" type="text" (focus)="onInputFocus($event)" (keydown)="onInputFieldKeyDown($event)" (keyup)="onInputFieldKeyUp($event)" (ngModelChange)="onItemChange($event)" [(ngModel)]="qText" autocomplete="off"/>    <label *ngIf="labelText" class="sr-only" [id]="idPrefix + 'search-box-label'" [attr.for]="idPrefix+'q-field'" [innerText]="labelText"></label>

    <button type="button" [disabled]="isDisabled" #searchBtn class="ant-search-button psButton" tabindex="-1" [id]="idPrefix+'search-btn'" (click)="onSearchButtonClick($event)">
      <span class="sr-only" [innerText]="ariaSearchButton"></span>
      <span class="psArrow fa fa-caret-down"></span>
    </button>

    <div #psDropdown [id]="idPrefix+'psDropdown-container'" class="psDropdown" tabindex="-1" *ngIf="dropdownOpened" [style.height]="itemsHeight+'px'" [ngClass]="{'active': dropdownOpened, 'noresults': noSuggestions}">

        <div *ngIf="noSuggestions" [innerText]="noSuggestionsMsg" class="no-suggestions">
        </div>

        <ng-container *ngFor="let item of result; let i = index;">

          <input #itemInput
            [id]="idPrefix+'ddlInput'+i"
            [attr.name]="idPrefix+'ddlInput'"
            type="radio"
            class="psOption"
            [value]="item.label"
            [attr.data-analytics]="item.analytics ? item.analytics : null"
            [checked]="selectedIndex === i"
            (click)="onItemClick(item.label)"/>

          <label #itemLabel
            [id]="idPrefix+'ddlLabel'+i"
            [ngClass]="{'psDisabled': item.disabled, 'active': (item.label.toUpperCase() === qText.trim().toUpperCase())}"
            [attr.for]="idPrefix+'ddlInput'+i"
            class="psLabel"
            [innerHTML]="item.label">
          </label>

        </ng-container>
    </div>

  </fieldset>`,
                    providers: [AUTOSUGGEST_COMPONENT_VALUE_ACCESSOR]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { legend: [{
                type: Input
            }], ignoreCase: [{
                type: Input
            }], ariaSearchButton: [{
                type: Input
            }], noSuggestionsMsg: [{
                type: Input
            }], labelText: [{
                type: Input
            }], defaultText: [{
                type: Input
            }], noAutoSuggest: [{
                type: Input
            }], alphabetize: [{
                type: Input
            }], itemsContainParentheses: [{
                type: Input
            }], analytics: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], onChange: [{
                type: Output
            }], itemLabels: [{
                type: ViewChildren,
                args: ["itemLabel", { read: ViewContainerRef }]
            }], itemInputs: [{
                type: ViewChildren,
                args: ['itemInput', { read: ViewContainerRef }]
            }], dropDown: [{
                type: ViewChild,
                args: ['psDropdown', { read: ViewContainerRef, static: false }]
            }], searchInput: [{
                type: ViewChild,
                args: ['searchInput']
            }], items: [{
                type: Input
            }], idPrefix: [{
                type: Input
            }], onDocumentClick: [{
                type: HostListener,
                args: ["document:click", ["$event"]]
            }] } });

//istanbul ignore next
class DateTextboxDirective {
    _onChangeCallback(value) {
        // noop
    }
    _onTouchedCallback() {
        // noop
    }
    constructor(_element, renderer, _datePipe) {
        this._element = _element;
        this.renderer = renderer;
        this._datePipe = _datePipe;
        this.jElem = $(this._element.nativeElement);
    }
    writeValue(value) {
        this.ngOnChanges({ _modelValue: { currentValue: value } });
    }
    registerOnChange(fn) {
        //todo
        this._onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        //todo
        this._onTouchedCallback = fn;
    }
    ngAfterViewInit() {
        this.setupDatePicker();
    }
    ngOnChanges(changes) {
        if (typeof changes['_modelValue'] !== 'undefined') {
            if (changes['_modelValue'].currentValue) {
                this.renderer.addClass(this._element.nativeElement, 'hasValue');
            }
            else {
                this.renderer.removeClass(this._element.nativeElement, 'hasValue');
            }
            this._element.nativeElement.value = changes['_modelValue'].currentValue || '';
        }
    }
    ngOnDestroy() {
        if (this.jElem) {
            this.jElem.datepicker('destroy');
        }
    }
    onChange() {
        this._onChangeCallback(this._element.nativeElement.value);
    }
    setupDatePicker() {
        this.jElem.datepicker({
            showOn: 'button',
            buttonText: '<span class="ant-calendar-icon ant-calendar-calendar"></span>',
            showOtherMonths: true,
            beforeShow: (input, inst) => {
                if (this._maxDate) {
                    $(this.jElem).datepicker('option', 'maxDate', this._maxDate);
                }
                if (this._minDate) {
                    $(this.jElem).datepicker('option', 'minDate', this._minDate);
                }
                this.jElem
                    .next()
                    .find('.ant-calendar-icon')
                    .removeClass('ant-calendar-calendar')
                    .addClass('ant-calendar-remove');
                return;
            },
            onClose: (e) => {
                if (this._element.nativeElement.value !== '') {
                    this.renderer.addClass(this._element.nativeElement, 'hasValue');
                }
                else {
                    this.renderer.removeClass(this._element.nativeElement, 'hasValue');
                }
                this._onTouchedCallback();
                this._onChangeCallback(this._element.nativeElement.value);
                this._element.nativeElement.focus();
                this.jElem
                    .next()
                    .find('.ant-calendar-icon')
                    .addClass('ant-calendar-calendar')
                    .removeClass('ant-calendar-remove');
            }
        });
        $(window).resize(() => {
            this.jElem.datepicker('hide');
        });
        if (this._maxDate) {
            this.jElem.datepicker('option', 'maxDate', this._datePipe.transform(this._maxDate, 'M/d/yyyy') || this._maxDate || '');
        }
        if (this._minDate) {
            this.jElem.datepicker('option', 'minDate', this._datePipe.transform(this._minDate, 'M/d/yyyy') || this._minDate || '');
        }
        const btn = this.jElem.next();
        btn.prop('tabindex', '-1');
        btn.attr('aria-hidden', 'true');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DateTextboxDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1.DatePipe }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: DateTextboxDirective, selector: "[data-is-date]", inputs: { _maxDate: ["maxDate", "_maxDate"], _minDate: ["minDate", "_minDate"] }, host: { listeners: { "keyup": "onChange()" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DateTextboxDirective),
                multi: true
            },
            DatePipe
        ], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DateTextboxDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-is-date]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DateTextboxDirective),
                            multi: true
                        },
                        DatePipe
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.DatePipe }]; }, propDecorators: { _maxDate: [{
                type: Input,
                args: ['maxDate']
            }], _minDate: [{
                type: Input,
                args: ['minDate']
            }], onChange: [{
                type: HostListener,
                args: ['keyup']
            }] } });

//istanbul ignore next
/**
 *  this allows wrapping input text element with security masking.
 *
 *  ###Example
 *
 *  Use below sample to create a card component
 *  ```html
 *  <div data-tcp-card-cmp [title]="Title string">
 *    <div>Content ... </div>
 *    <button >Sample button content </button>
 *  </div>
 * ```
 *
 * Optional attribute
 * ```
 * data-title-id : 'string'
 * ```
 */
class SecurityMaskDirective {
    get masked() {
        return this._masked;
    }
    set masked(isMasked) {
        isMasked ? this._updateTypeAttribute('password') : this._updateTypeAttribute('text');
        this._masked = isMasked;
        this.onChange.emit();
    }
    constructor(_eleRef) {
        this._eleRef = _eleRef;
        this._masked = true;
        this.onChange = new EventEmitter();
    }
    ngOnInit() {
        this.masked = this.masked;
    }
    get _ariaText() {
        if (!this.definition) {
            return null;
        }
        return this.masked
            ? this.definition.ariaLabelMasked // If masked ...
            : this.definition.ariaLabelUnMasked; /// Else if un-masked
    }
    onMaskClick(event) {
        this._toggleMaskedState();
        event.preventDefault();
    }
    _toggleMaskedState() {
        this.masked = !this._masked;
    }
    _updateTypeAttribute(type) {
        if (this.definition && this.definition.maskedInput) {
            this.definition.maskedInput.setAttribute('type', type);
        }
        else {
            throw Error("Security Mask: unable to set 'type' attribute on input");
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SecurityMaskDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SecurityMaskDirective, selector: "[data-uxd-security-mask-cmp]", inputs: { ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledBy: ["aria-labelledby", "ariaLabelledBy"], definition: "definition", masked: "masked" }, outputs: { onChange: "onChange" }, host: { classAttribute: "ant-data-security-mask ant-info-icon" }, exportAs: ["securtityMask"], ngImport: i0, template: `
    <button
      role="button"
      type="button"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledBy"
      [attr.aria-pressed]="masked"
      class="ant-security-mask-btn"
      (click)="onMaskClick($event)">
      <span class="sr-only" *ngIf="_ariaText">{{ _ariaText }}</span>
      <span aria-hidden="true" class="ant-security-mask-icon" [class.is-masked]="masked"></span>
    </button>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SecurityMaskDirective, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-security-mask-cmp]',
                    host: {
                        class: 'ant-data-security-mask ant-info-icon'
                    },
                    template: `
    <button
      role="button"
      type="button"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledBy"
      [attr.aria-pressed]="masked"
      class="ant-security-mask-btn"
      (click)="onMaskClick($event)">
      <span class="sr-only" *ngIf="_ariaText">{{ _ariaText }}</span>
      <span aria-hidden="true" class="ant-security-mask-icon" [class.is-masked]="masked"></span>
    </button>
  `,
                    exportAs: 'securtityMask'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], ariaLabelledBy: [{
                type: Input,
                args: ['aria-labelledby']
            }], definition: [{
                type: Input
            }], masked: [{
                type: Input
            }], onChange: [{
                type: Output
            }] } });

//istanbul ignore next
class TextboxDirective {
    constructor(_element, renderer) {
        this._element = _element;
        this.renderer = renderer;
    }
    onFocus() {
        this.renderer.addClass(this._element.nativeElement, 'focus');
    }
    onBlur() {
        this.renderer.removeClass(this._element.nativeElement, 'focus');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextboxDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: TextboxDirective, selector: "[data-uxd-text-dir]", host: { listeners: { "focus": "onFocus()", "blur": "onBlur()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextboxDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[data-uxd-text-dir]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

/*  ====================  UXD TEXT INPUT ====================
 *  creation data:  June 17, 2017
 * This component is a near complete copy of Google's Material input, which
 * may be found on their GitHub page.
 * https://material.angular.io/components/component/input
 *  =========================================================== */
// tslint:disable:class-name
class uxdInputSuffix {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputSuffix, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: uxdInputSuffix, selector: "data-uxd-input-suffix-dir", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputSuffix, decorators: [{
            type: Directive,
            args: [{
                    selector: "data-uxd-input-suffix-dir"
                }]
        }] });
class uxdInputPrefix {
    constructor() {
        this._id = "";
    }
    /*The id of the text input itself (set by container)*/
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputPrefix, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: uxdInputPrefix, selector: "data-uxd-input-prefix-dir", host: { properties: { "id": "id ? id+'__prefix' : null", "attr.id": "id ? id+'__prefix' : null" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputPrefix, decorators: [{
            type: Directive,
            args: [{
                    selector: "data-uxd-input-prefix-dir",
                    host: {
                        "[id]": "id ? id+'__prefix' : null",
                        "[attr.id]": "id ? id+'__prefix' : null"
                    }
                }]
        }] });
/** Marker for the input element that textInputContainer is wrapping */
class uxdInputDirective {
    get ariaDescribedbyID() {
        return this._ariaDescribedbyID;
    }
    set ariaDescribedbyID(id) {
        this._ariaDescribedbyID = id;
    }
    /** placeholder Attribute of the element*/
    get placeholder() {
        return this._placeholderString;
    }
    set placeholder(placeholder) {
        if (this._placeholderString !== placeholder) {
            this._placeholderString = placeholder;
            this._placeholderChange.emit(this._placeholderString);
        }
    }
    /*The id of the text input itself (set by container)*/
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    /** Whether the input is required */
    get required() {
        return this._isRequired;
    }
    set required(value) {
        this._isRequired = value;
    }
    /** Input type of element */
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value || "text";
    }
    /** The input element's value */
    get value() {
        return this._elementRef.nativeElement.value;
    }
    set value(value) {
        this._elementRef.nativeElement.value = value;
    }
    /** whether the input is currently empty */
    get isEmpty() {
        return (!this._isNeverEmpty() &&
            (this.value == null || this.value === "") &&
            (this.placeholder == null || this.placeholder === ""));
    }
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this._isRequired = false;
        this._id = "";
        /* An array of input types for which the text input should never default to empty state.*/
        this._neverEmptyInputTypes = ["date", "datetime", "month"];
        /**
         * Emits an event when the placeholder changes so that the container can re-validate.*/
        this._placeholderChange = new EventEmitter();
        /** whether the element is focused or not */
        this.isFocused = false;
        if (this._elementRef) {
            // Set the aria-describedby value to the native value on the input, otherwise use an empty string
            this._ariaDescribedbyID =
                this._elementRef.nativeElement.getAttribute("aria-describedby") || "";
        }
    }
    focus() {
        this._elementRef.nativeElement.focus();
    }
    _onFocus() {
        this.isFocused = true;
    }
    _onBlur() {
        this.isFocused = false;
    }
    _onInput() {
        /*noop*/
    }
    _isNeverEmpty() {
        return this._neverEmptyInputTypes.indexOf(this._type) !== -1;
    }
    _validateType() {
        if (false) {
            //throw an error if the child input is not a supported type
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: uxdInputDirective, selector: "input[data-uxd-text-input-dir]", inputs: { placeholder: "placeholder", required: "required", type: "type" }, outputs: { _placeholderChange: "_placeholderChange" }, host: { listeners: { "focus": "_onFocus()", "blur": "_onBlur()" }, properties: { "id": "id ? id+'__input' : null", "attr.id": "id ? id+'__input' : null", "attr.placeholder": "placeholder || null", "attr.aria-describedby": "ariaDescribedbyID || null", "required": "required", "type": "type", "attr.type": "type" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "input[data-uxd-text-input-dir]",
                    host: {
                        "[id]": "id ? id+'__input' : null",
                        "[attr.id]": "id ? id+'__input' : null",
                        "[attr.placeholder]": "placeholder || null",
                        "[attr.aria-describedby]": "ariaDescribedbyID || null",
                        "[required]": "required",
                        "[type]": "type",
                        "[attr.type]": "type",
                        "(focus)": "_onFocus()",
                        "(blur)": "_onBlur()"
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { placeholder: [{
                type: Input
            }], _placeholderChange: [{
                type: Output
            }], required: [{
                type: Input
            }], type: [{
                type: Input
            }] } });
class uxdInputError {
    constructor(el) {
        this._el = el;
        this.id = this._el.nativeElement.id;
    }
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputError, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: uxdInputError, selector: "[data-uxd-error-dir]", inputs: { id: "id" }, host: { attributes: { "role": "alert" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdInputError, decorators: [{
            type: Directive,
            args: [{
                    host: {
                        role: "alert"
                    },
                    selector: "[data-uxd-error-dir]"
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { id: [{
                type: Input
            }] } });
/**
 * Container for text inputs
 */
class uxdTextInputContainer {
    constructor(_elementRef, _changeDetectorRef) {
        this._elementRef = _elementRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._isRequired = false;
        this._placeholder = "";
        this._definition = null;
        /**
         * If no definition exists, use the static
         * values supplied to the id and label attributes
         */
        this._type = this.type;
        this._id = this.id;
        this._label = this.label;
        this._placeholder = this.placeholder;
    }
    get definition() {
        return this._definition;
    }
    set definition(definitionObj) {
        this._definition = {
            id: definitionObj.id,
            type: definitionObj.type,
            label: definitionObj.label,
            isRequired: definitionObj.isRequired,
            placeholder: definitionObj.placeholder
        };
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get label() {
        return this._label;
    }
    set label(value) {
        this._label = value;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get required() {
        return this._isRequired;
    }
    set required(value) {
        this._isRequired = value;
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(value) {
        this._placeholder = value;
    }
    ngOnInit() {
        /**
         * When the definition object does exist, use
         * thoe values of that object.
         */
        if (this._definition) {
            this.id = this._definition.id;
            this.label = this._definition.label;
            this.placeholder = this._definition.placeholder;
            this.type = this._definition.type;
            this._isRequired = this._definition.isRequired;
        }
    }
    ngAfterContentInit() {
        if (!this._uxdInputChild) {
            console.error('An input with the uxdInputDirective directive is expected');
            return;
        }
        // Set the id, type, and other attributes of the text input
        this._uxdInputChild.id = this.id;
        this._uxdInputChild.type = this.type || 'text';
        this._uxdInputChild.placeholder = this.placeholder;
        this._uxdInputChild.required = this._isRequired;
        this._uxdInputChild.ariaDescribedbyID = [this._uxdInputChild.ariaDescribedbyID, `${this.id}__label`, `${this.id}__error`].join(' ');
        let initAriaDescribedbyID = this._uxdInputChild.ariaDescribedbyID;
        if (this._uxdInputErrors) {
            this._uxdInputErrors.changes.subscribe(() => {
                this._uxdInputChild.ariaDescribedbyID = initAriaDescribedbyID;
                this._uxdInputChild.ariaDescribedbyID += ' ' + this._syncAriaDescribedby().join(' ');
            });
        }
    }
    ngAfterViewInit() {
        //nop
    }
    ngAfterContentChecked() {
        //nop
    }
    /**
     * Sets the child input's `aria-describedby` to a space-separated list of the ids
     * of the currently-specified hints, as well as a generated id for the hint label.
     */
    _syncAriaDescribedby() {
        if (this._uxdInputChild) {
            let ids = [];
            // Set the ID of the error message, for the purpose of aria-described by
            if (this._uxdInputErrors) {
                this._uxdInputErrors.forEach(childError => {
                    ids.push(childError.id);
                });
            }
            return ids;
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdTextInputContainer, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: uxdTextInputContainer, selector: "[data-uxd-text-container-cmp]", inputs: { definition: "definition", id: "id", label: "label", type: "type", required: "required", placeholder: "placeholder" }, queries: [{ propertyName: "_uxdInputChild", first: true, predicate: uxdInputDirective, descendants: true }, { propertyName: "_uxdInputErrors", predicate: uxdInputError }], ngImport: i0, template: `
    <ng-content select="data-uxd-input-prefix-dir"></ng-content>
    <div class="uxd-text-input"    [attr.id]="id ? id+'__container' : null">
    <label
      [attr.id]="id ? id+'__label' : null"
      [attr.for]="id ? id+'__input' : null"
      class="uxd-text-input__label"
      [class.is-focused]='_uxdInputChild.isFocused || !_uxdInputChild.isEmpty'><span>{{label}}</span></label>
      <ng-content select="input[data-uxd-text-input-dir]"></ng-content>
      <span class="bottom-bar"
        [class.is-focused]='_uxdInputChild.isFocused' [class.is-active]="!_uxdInputChild.isEmpty"></span>
        <ng-content select="data-uxd-input-suffix-dir"></ng-content>
        <div class="uxd-error-message" [attr.id]="id ? id+'__error' : null" [id]="id ? id+'__error' : null">
          <ng-content select=".uxd-error-container"></ng-content>
          <ng-content select="[data-uxd-error-dir]"></ng-content>
        </div>
    </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: uxdTextInputContainer, decorators: [{
            type: Component,
            args: [{
                    selector: "[data-uxd-text-container-cmp]",
                    template: `
    <ng-content select="data-uxd-input-prefix-dir"></ng-content>
    <div class="uxd-text-input"    [attr.id]="id ? id+'__container' : null">
    <label
      [attr.id]="id ? id+'__label' : null"
      [attr.for]="id ? id+'__input' : null"
      class="uxd-text-input__label"
      [class.is-focused]='_uxdInputChild.isFocused || !_uxdInputChild.isEmpty'><span>{{label}}</span></label>
      <ng-content select="input[data-uxd-text-input-dir]"></ng-content>
      <span class="bottom-bar"
        [class.is-focused]='_uxdInputChild.isFocused' [class.is-active]="!_uxdInputChild.isEmpty"></span>
        <ng-content select="data-uxd-input-suffix-dir"></ng-content>
        <div class="uxd-error-message" [attr.id]="id ? id+'__error' : null" [id]="id ? id+'__error' : null">
          <ng-content select=".uxd-error-container"></ng-content>
          <ng-content select="[data-uxd-error-dir]"></ng-content>
        </div>
    </div>
  `
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { definition: [{
                type: Input
            }], id: [{
                type: Input
            }], label: [{
                type: Input
            }], type: [{
                type: Input
            }], required: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], _uxdInputChild: [{
                type: ContentChild,
                args: [uxdInputDirective]
            }], _uxdInputErrors: [{
                type: ContentChildren,
                args: [uxdInputError]
            }] } });

class InputModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: InputModule, declarations: [AutoSuggestComponent, DateTextboxDirective, TextboxDirective, SecurityMaskDirective, uxdInputSuffix, uxdInputPrefix, uxdInputDirective, uxdInputError, uxdTextInputContainer], imports: [CommonModule, FormsModule], exports: [AutoSuggestComponent, DateTextboxDirective, TextboxDirective, SecurityMaskDirective, uxdInputSuffix, uxdInputPrefix, uxdInputDirective, uxdInputError, uxdTextInputContainer] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputModule, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [AutoSuggestComponent, DateTextboxDirective, TextboxDirective, SecurityMaskDirective, uxdInputSuffix, uxdInputPrefix, uxdInputDirective, uxdInputError, uxdTextInputContainer],
                    exports: [AutoSuggestComponent, DateTextboxDirective, TextboxDirective, SecurityMaskDirective, uxdInputSuffix, uxdInputPrefix, uxdInputDirective, uxdInputError, uxdTextInputContainer]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AUTOSUGGEST_COMPONENT_VALUE_ACCESSOR, AutoSuggestComponent, DateTextboxDirective, InputModule, SecurityMaskDirective, TextboxDirective, uxdInputDirective, uxdInputError, uxdInputPrefix, uxdInputSuffix, uxdTextInputContainer };
